import { render, staticRenderFns } from "./RegistrationCgv.vue?vue&type=template&id=e67c3480&scoped=true&"
import script from "./RegistrationCgv.vue?vue&type=script&lang=js&"
export * from "./RegistrationCgv.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationCgv.vue?vue&type=style&index=0&id=e67c3480&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e67c3480",
  null
  
)

export default component.exports